import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { toDate } from '@df/util/fn/to-date';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface IPageComponentJobVacancyTimerComponentData extends NICmsContentComponent.IData {
    title: string;
    jobs: IJobVacancy[];
}
export interface IJobVacancy {
    title?: string;
    location?: string;
    closing_date?: string;
    cta_link?: string;
    cta_copy?: string;
}
@Component({
    selector: 'page-component-job-vacancy-timer',
    templateUrl: 'job-vacancy-timer.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, HrefComponent, OrdinalPipe, TranslationModule, GridModule, ICmsClientModule]
})
@ICmsComponent<PageComponentJobVacancyTimerComponent>({
    id: 'job-vacancy-timer',
    name: 'Job Vacancy Timer',
    tags: ['Job', 'Content', 'Timer'],
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            key: 'jobs',
            title: 'Jobs',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Job',
            itemNameField: 'title',
            defaultSize: 1,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'location',
                    title: 'Location'
                },
                {
                    type: NICmsContentField.EFieldType.date,
                    key: 'closing_date',
                    title: 'Closing Date'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_copy',
                    title: 'CTA Copy'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_link',
                    title: 'CTA Link'
                }
            ]
        }
    ]
})
export class PageComponentJobVacancyTimerComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentJobVacancyTimerComponentData;

    get visibleJobs(): IJobVacancy[] {
        const date = new Date();
        return this?.component.jobs.filter(job => toDate(job.closing_date)! > date);
    }
}
